areaMembros.component('areaMembros.guiaEditComponent', {
    templateUrl: 'areaMembros/areaMembrosDetalhe/guiaEdit/guiaEdit.html',
    controller: 'areaMembros.guiaController',
    controllerAs: '$ctrl',
    bindings: { areaMembros: '<', tab: '<' }
});

areaMembros.controller('areaMembros.guiaController', ['$scope', 'coreLanguage', '$state', 'coreFb', 'coreToast', '$filter', function($scope, $text, $state, $fb, $toast, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.viewFormBanner=false;
    $ctrl.viewForm=false;
    $ctrl.showProdutos=false;
    $ctrl.produto=null;

    const _getProdutos=()=>{
        $ctrl.produtos = [];

        $fb.db.list(`cad_produtos`, [{where:['criacao.idUsuario', '==', $ctrl.idUsuario]}]).then(list=>{
            $ctrl.produtos = list.map(item=>{ 
                return {
                    id: item.id,
                    nome: item.data.nome,
                    interno: !!item.data.interno,
                    capaUrl: item.data.perfilUrl || null
                }
            }).filter(item=>!item.interno);
        });
    };

    $ctrl.updateGuia=()=>{
        $state.params.showGlobalLoading = true;

        $ctrl.areaMembros.data.tabs.forEach(item=>{
            if((item.value === $ctrl.areaTab.value) && 
                (item.label !== $ctrl.guia.nome))
            { item.label = $ctrl.guia.nome; }
        });
        
        $fb.db.update($ctrl.areaMembros.path, {[$ctrl.tab]: $ctrl.guia, tabs: $ctrl.areaMembros.data.tabs })
        .then(res=>{
            $ctrl.areaMembros.data[$ctrl.tab] = angular.copy($ctrl.guia);
            $ctrl.showProdutos = false;
            $state.params.showGlobalLoading = false;

        }).catch(e=>{
            console.log(e);
        });
    };

    $ctrl.countProd=(prods)=>{
        return prods ? Object.values(prods).filter(item=> item).length : 0;
    };

    $ctrl.deleteTab=(tab)=>{
        $state.params.showGlobalLoading = true;
        let tabs = $ctrl.areaMembros.data.tabs.filter(item=> item.value !== tab);

        $fb.db.update($ctrl.areaMembros.path, {[tab]: {ativo: false}, tabs: tabs})
        .then(()=>{
            $ctrl.areaMembros.data.tabs = tabs;
            $ctrl.areaMembros.data[tab] = {ativo:false};

            $state.params.showGlobalLoading = false;
            
        }).catch(e=>{
            $state.params.showGlobalLoading = false;
            console.log(e);
        });
    };

    $ctrl.uploadBanner=(event, mobile = false)=>{

        const file = event.target.files[0]
        const ext = file.name.split('.').pop();

        if (!['png', 'jpg', 'jpeg', 'webp', 'svg'].includes(ext.toLowerCase())) {
            return
        }

        $ctrl.loadingFile=true;

        $fb.storage.upload(`/areaMembros/${$ctrl.areaMembros.id}`, event.target.files[0]).then(url => {
            if(!mobile){
                $ctrl.guia.capaUrl = url;
            }else{
                $ctrl.guia.capaMobUrl = url;
            }

            $ctrl.loadingFile=false;
        });

    };

    $ctrl.updateBanner=(tab)=>{
        $state.params.showGlobalLoading = true;

        $fb.db.update($ctrl.areaMembros.path, {
            [`${tab}.capaUrl`]: $ctrl.guia.capaUrl, 
            [`${tab}.capaMobUrl`]: $ctrl.guia.capaMobUrl, 
            [`${tab}.link`]: $ctrl.guia.link || null
        }).then(()=>{ $state.reload(); });
    };

    $ctrl.addProduto=(produto)=>{
        if(!$ctrl.guia.produtos){ $ctrl.guia.produtos = []; }
        let hasProduto = $filter('filter')($ctrl.guia.produtos, {id: produto.id});
        if(hasProduto.length){
            $toast.success($text.alreadyAdded);
            return;
        }

        $ctrl.guia.produtos.push({id:produto.id, capaUrl: produto.capaUrl })
        $ctrl.produto = null;
    };

    $ctrl.deleteProduto=(idx)=>{
        $ctrl.guia.produtos.splice(idx, 1);
    };

    $ctrl.getProdName=(id)=>{
        if(!$ctrl.produtos){
            return;
        }

        let hasProduto = $filter('filter')($ctrl.produtos, {id:id});

        if(!hasProduto.length){
            return;
        }

        return hasProduto[0].nome;
    };

    $ctrl.updateProdutos=(tab)=>{
        $state.params.showGlobalLoading = true;

        $fb.db.update($ctrl.areaMembros.path, {
            [`${tab}.produtos`]: $ctrl.guia.produtos})
        .then(()=>{
            $state.reload();
        });
    };

    const _initTab=()=>{
        $ctrl.guia = angular.copy($ctrl.areaMembros.data[$ctrl.tab]);
        if(!$ctrl.guia){ 
            $state.reload(); 
        }else{
            $ctrl.areaTab = $ctrl.areaMembros.data.tabs.find(item=> item.value === $ctrl.tab );
            $ctrl.guia.nome = $ctrl.guia.nome || $ctrl.areaTab.label || '';
        }
    };

    $scope.$watch('$ctrl.tab', (newValue)=>{ _initTab(); });

    $ctrl.$onInit=()=>{
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idMaster || $fb.auth.getIdToken().claims.idUsuario;

        _getProdutos();
        _initTab();
    };

}]);